import mainReducer from './reducers'
import createLogger from 'redux-logger'
import thunk from 'redux-thunk'
import { createStore, applyMiddleware, compose } from 'redux'
import {GetInitialState} from './reducers/initialState'

import createSagaMiddleware from 'redux-saga'
//import { soundSaga, main, rootSaga } from './sagas'
import rootSaga from './sagas/root'

export default function getStore(){
    const logger = createLogger();

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const sagaMiddleware = createSagaMiddleware()

    const store = createStore(
      mainReducer,
      GetInitialState(),
      composeEnhancers(process.env.NODE_ENV == "production" ? applyMiddleware(thunk, sagaMiddleware) : applyMiddleware(thunk, logger, sagaMiddleware)))

    sagaMiddleware.run(rootSaga);

    return store;
}



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/